{
  "CONTENT_SLUG_INVALID": "Slug may only contain lowercase letters, numbers and hyphens",
  "CONTENT_LINK_NOT_FOUND": "Link not found",
  "PRODUCT_NOT_FOUND": "Product not found",
  "PRODUCT_ARCHIVED_NOT_FOUND": "Archived product not found",
  "PRODUCT_SLUG_TAKEN": "A product with this slug already exists",
  "PRODUCT_STATUS_INVALID": "Status must be DRAFT, PUBLISHED or ARCHIVED",
  "PRODUCT_TARGET_COURSE_NOT_FOUND": "Target course not found",
  "PRODUCT_DELETED": "Product deleted successfully",
  "PRODUCT_DRAFTS_DELETED": "{{count}} draft course(s) deleted successfully",
  "PRODUCT_CONVERTED_TO_MODULE": "Course \"{{title}}\" converted into a module with {{count}} lessons",
  "PRODUCT_MERGED_TO_COURSE": "{{count}} course(s) converted into modules of \"{{title}}\"",
  "CMS_PAGE_NOT_FOUND": "Page not found",
  "CMS_PAGE_SLUG_TAKEN": "A page with this slug already exists",
  "CMS_PAGE_DELETED": "Page deleted successfully",
  "CMS_SECTION_NOT_FOUND": "Section not found",
  "CMS_SECTION_IDENTIFIER_TAKEN": "A section with this identifier already exists on this page",
  "CMS_SECTION_DELETED": "Section deleted successfully",
  "CMS_BLOCK_NOT_FOUND": "Block not found",
  "CMS_BLOCK_DELETED": "Block deleted successfully",
  "CMS_TEMPLATE_NOT_FOUND": "Template not found",
  "CMS_COMPONENT_NOT_FOUND": "Component not found",
  "CERTIFICATE_NOT_FOUND": "Certificate not found",
  "CERTIFICATE_REVOKED": "Certificate revoked",
  "CERTIFICATE_TEMPLATE_NOT_FOUND": "Template not found",
  "CERTIFICATE_TEMPLATE_DEFAULT_NOT_DELETABLE": "The default template cannot be deleted",
  "CERTIFICATE_TEMPLATE_IN_USE": "This template is being used by {{count}} certificate(s)",
  "CERTIFICATE_TEMPLATE_DELETED": "Template deleted successfully",
  "CERTIFICATE_PRODUCT_NOT_COMPLETED": "User has not completed this product",
  "CERTIFICATE_USER_OR_PRODUCT_NOT_FOUND": "User or product not found",
  "CERTIFICATE_MEMBER_NOT_FOUND": "Member not found",
  "CERTIFICATE_CONTENT_REQUIRED": "Select a content item to issue",
  "CERTIFICATE_CONTENT_NOT_FOUND": "Content not found",
  "CUSTOMIZATION_PRIMARY_COLOR_INVALID": "Primary color must be a valid hex code",
  "CUSTOMIZATION_SECONDARY_COLOR_INVALID": "Secondary color must be a valid hex code",
  "CUSTOMIZATION_FILE_REQUIRED": "No file uploaded",
  "CUSTOMIZATION_FILE_TYPE_INVALID": "Accepted formats: {{formats}}",
  "CUSTOMIZATION_FILE_TOO_LARGE": "File must be at most {{max}}MB",
  "PRODUCT_APPEARANCE_COURSE_NOT_FOUND": "Course not found",
  "PRODUCT_APPEARANCE_SECTION_NOT_FOUND": "Section not found",
  "PRODUCT_APPEARANCE_SECTION_REMOVED": "Section removed successfully",
  "PRODUCT_APPEARANCE_SECTIONS_REORDERED": "Sections reordered successfully",
  "PRODUCT_APPEARANCE_MENU_ITEM_NOT_FOUND": "Menu item not found",
  "PRODUCT_APPEARANCE_MENU_ITEM_REMOVED": "Menu item removed successfully",
  "PRODUCT_APPEARANCE_MENU_REORDERED": "Menu reordered successfully",
  "MEMBER_AREA_NOT_FOUND": "Member area not found",
  "MEMBER_AREA_SLUG_TAKEN": "This slug is already in use",
  "MEMBER_AREA_INACTIVE": "This member area is not active",
  "MEMBER_AREA_COLOR_INVALID": "Color must be in hex format (#RRGGBB)",
  "MEMBER_AREA_DELETED": "Member area deleted successfully",
  "MEMBER_AREA_BANNER_NOT_FOUND": "Banner not found",
  "MEMBER_AREA_BANNER_DELETED": "Banner deleted successfully",
  "MEMBER_AREA_BANNERS_REORDERED": "Banners reordered successfully",
  "MEMBER_AREA_MENU_ITEM_NOT_FOUND": "Menu item not found",
  "MEMBER_AREA_MENU_ITEM_DELETED": "Menu item deleted successfully",
  "MEMBER_AREA_MENU_REORDERED": "Menu reordered successfully",
  "COURSE_SECTION_NOT_FOUND": "Section with ID {{id}} not found",
  "COURSE_SECTION_SOME_NOT_FOUND": "One or more sections do not exist",
  "COURSE_SECTION_PRODUCT_NOT_FOUND": "Product with ID {{id}} not found",
  "COURSE_SECTION_PRODUCT_ALREADY_ADDED": "Product is already in this section",
  "COURSE_SECTION_PRODUCT_NOT_IN_SECTION": "Product is not in this section",
  "COURSE_SECTION_PRODUCTS_NOT_IN_SECTION": "One or more products are not in this section",
  "CATEGORY_NOT_FOUND": "Category not found",
  "CATEGORY_SLUG_TAKEN": "Slug already exists",
  "CATEGORY_DELETED": "Category deleted",
  "LEARNING_TRAIL_NOT_FOUND": "Learning path not found",
  "LEARNING_TRAIL_PRODUCTS_NOT_FOUND": "One or more products were not found",
  "LEARNING_TRAIL_UNAVAILABLE": "This learning path is not available",
  "LEARNING_TRAIL_ALREADY_ENROLLED": "User is already enrolled in this learning path",
  "LEARNING_TRAIL_ENROLLMENT_NOT_FOUND": "Learning path enrollment not found",
  "MODULE_NOT_FOUND": "Module not found",
  "MODULE_PARENT_NOT_FOUND": "Parent module not found",
  "MODULE_ALREADY_LINKED": "Module is already linked to this course",
  "MODULE_SECTION_DELETED": "Section deleted. Submodules were unlinked.",
  "MODULE_CHILDREN_REORDERED": "Submodules reordered",
  "MODULE_UNLINKED": "Module unlinked from course",
  "LESSON_NOT_FOUND": "Lesson not found",
  "LESSON_ACCESS_DENIED": "You don't have access to this lesson",
  "LESSON_ALREADY_LINKED": "Lesson is already linked to this module",
  "LESSON_DELETED": "Lesson deleted",
  "LESSON_UNLINKED": "Lesson unlinked from module",
  "ANALYTICS_EXPORT_TYPE_INVALID": "Invalid export type",
  "PRODUCT_ACCESS_DENIED": "You don't have access to this course",
  "PRODUCT_VISIBILITY_INVALID": "Visibility must be HIDDEN or LOCKED",
  "CUSTOMIZATION_THEME_INVALID": "Theme mode must be STUDENT_CHOICE, LIGHT or DARK",
  "LESSON_VIDEO_PROVIDER_INVALID": "Video provider must be gumlet, youtube, vimeo, panda or direct",
  "LESSON_VIDEO_URL_INVALID": "Invalid video link for the chosen provider",
  "LESSON_COMPLETION_TRACKED_BY_PLAYER": "This lesson is completed automatically when you watch the video"
}
